import find from 'lodash/find'
import map from 'lodash/map'
import React from 'react'
import type { SelectProps, SelectOption } from '@ztechapps/webui.input'
import { Select } from '@ztechapps/webui.input'
import { UsStateList } from '@ztechapps/common.contract'
import type { SingleValue } from 'react-select'

const options: SelectOption[] = map(UsStateList, (item) => ({ value: item.value, label: item.name }))

export const UsStateSelect = ({ value, ...rest }: SelectProps) => {
  //resolve the incoming value (object {value,label} or a raw string) by 2-letter code OR full state name —
  //legacy records saved the full name (e.g. "Texas"), so match both, then return the labeled option
  const _value = React.useMemo(() => {
    const singleValue = value as SingleValue<SelectOption>
    const raw = singleValue?.value ?? value
    const search = typeof raw === 'string' ? raw.trim().toLowerCase() : raw

    const found = find(
      UsStateList,
      (state) => state.value.toLowerCase() === search || state.name.toLowerCase() === search
    )

    return find(options, { value: found?.value })
  }, [value])

  return (
    <Select
      {...{
        ...rest,
        value: _value,
        options,
      }}
    />
  )
}
